import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { useEffect } from "react";

function valuetext(value) {
  return `₹${value}`;
}

const minDistance = 1000;

export default function PriceRange({ setFormData, name }) {
  const [value1, setValue1] = React.useState([4000, 20000]);

  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        [name]: {
          min: value1[0],
          max: value1[1],
        },
      };
    });
  }, [value1]);

  const handleChange1 = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) return;

    if (activeThumb === 0) {
      setValue1([Math.min(newValue[0], value1[1] - minDistance), value1[1]]);
    } else {
      setValue1([value1[0], Math.max(newValue[1], value1[0] + minDistance)]);
    }
  };

  return (
    <div>
      <Box sx={{ width: 300 }}>
        <Slider
          getAriaLabel={() => "Price range"}
          value={value1}
          onChange={handleChange1}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          min={1000}
          max={50000}
          step={100}
          disableSwap
        />
      </Box>
      <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ color: "black" }}>{`Min : ${value1[0]} INR`}</div>
        <div style={{ color: "black" }}>{`Max : ${value1[1]} INR`}</div>
      </div>
    </div>
  );
}
